import { TrainingRecordEdit } from '@client/components/compliance/training/TrainingRecordEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/training/search/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add completed training',
        },
    },
    component: TrainingRecordEdit,
});
